import { render, staticRenderFns } from "./createMpinComponent.vue?vue&type=template&id=4ebd09ff&"
import script from "./createMpinComponent.vue?vue&type=script&lang=js&"
export * from "./createMpinComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports